/** Review / LEC product day boundary — aligned with calendar gems & review reminders. */
export const REVIEW_DAY_BOUNDARY_HOUR = 3;

/**
 * Local wall-clock start of the current product day (default 03:00).
 * 00:00–02:59 still belongs to the previous product day.
 */
export function getReviewProductDayStart(
  now: Date = new Date(),
  dayBoundaryHour = REVIEW_DAY_BOUNDARY_HOUR,
): Date {
  const start = new Date(now);
  start.setHours(dayBoundaryHour, 0, 0, 0);
  if (now.getTime() < start.getTime()) {
    start.setDate(start.getDate() - 1);
  }
  return start;
}

export function getReviewProductDayStartMs(
  now: Date = new Date(),
  dayBoundaryHour = REVIEW_DAY_BOUNDARY_HOUR,
): number {
  return getReviewProductDayStart(now, dayBoundaryHour).getTime();
}

export function getReviewProductDayKey(
  now: Date = new Date(),
  dayBoundaryHour = REVIEW_DAY_BOUNDARY_HOUR,
): string {
  const start = getReviewProductDayStart(now, dayBoundaryHour);
  const year = start.getFullYear();
  const month = String(start.getMonth() + 1).padStart(2, '0');
  const day = String(start.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function isSameReviewProductDay(
  input?: string | null,
  now: Date = new Date(),
  dayBoundaryHour = REVIEW_DAY_BOUNDARY_HOUR,
): boolean {
  if (!input) return false;
  const source = new Date(input);
  if (Number.isNaN(source.getTime())) return false;
  const start = getReviewProductDayStart(now, dayBoundaryHour);
  const end = new Date(start);
  end.setDate(end.getDate() + 1);
  return source >= start && source < end;
}
